import MessageTypes from './MessageTypes';

export function updateTermOfUsage (data) {
  return {
    type: MessageTypes.UPDATE_TERM_OF_USAGE_REQUEST,
    payload: data
  };
}

export function loadSectionTitleDescription (data) {
  return {
    type: MessageTypes.GET_SECTION_TITLE_DESCRIPTION_REQUEST,
    payload: data
  };
}

export function loadTableHeading (data) {
  return {
    type: MessageTypes.GET_TABLE_HEADING_REQUEST,
    payload: data
  };
}

export function updateTitleDescription (data) {
  return {
    type: MessageTypes.UPDATE_TITLE_DESCRIPTION_REQUEST,
    payload: data
  };
}

export function updateTableHeading (data) {
  return {
    type: MessageTypes.UPDATE_TABLE_HEADING_REQUEST,
    payload: data
  };
}

export function updatePageTitle (data) {
  return {
    type: MessageTypes.UPDATE_PAGE_TITLE_REQUEST,
    payload: data
  };
}

export function getTabPageTitle (data) {
  return {
    type: MessageTypes.GET_TAB_PAGE_TITLE_REQUEST,
    payload: data
  };
}

export function updateTabPageTitle (data) {
  return {
    type: MessageTypes.UPDATE_TAB_PAGE_TITLE_REQUEST,
    payload: data
  };
}

export function updateAllTableHeadings (data) {
  return {
    type: MessageTypes.UPDATE_ALL_TABLE_HEADINGS,
    payload: data
  };
}

export function updateAllSectionDetails (data) {
  return {
    type: MessageTypes.UPDATE_ALL_SECTION_DETAILS,
    payload: data
  };
}

export function indexAllDataToElasticSearch (data) {
  return {
    type: MessageTypes.INDEX_ALL_DATA_TO_ELASTICSEARCH,
    payload: data
  };
}

// Preview
export function updateTermPreview (data) {
  return {
    type: MessageTypes.UPDATE_TERM_PREVIEW,
    payload: data
  };
}

export function updatePageTitlePreview (data) {
  return {
    type: MessageTypes.UPDATE_PAGE_TITLE_PREVIEW,
    payload: data
  };
}

export function updateTabTitlePreview (data) {
  return {
    type: MessageTypes.UPDATE_TAB_TITLE_PREVIEW,
    payload: data
  };
}

export function updateHeadingTablePreview (data) {
  return {
    type: MessageTypes.UPDATE_HEADING_TABLE_PREVIEW,
    payload: data
  };
}

export function updateSectionDetailPreview (data) {
  return {
    type: MessageTypes.UPDATE_SECTION_DETAIL_PREVIEW,
    payload: data
  };
}

export function updateAllPreview (data) {
  return {
    type: MessageTypes.UPDATE_ALL_PREVIEW,
    payload: data
  };
}
